import { lazy } from "react";

const HomePage = lazy(() => import("./food-page"));

const routes = [
  {
    path: "/foods",
    component: HomePage,
    exact: true,
    name: "Alimentos de Dietas de Nutrición"
  }
];

export default routes;
